// Map emoji strings to their respective grid positions
export const emojiMap = {
  ":)": { row: 0, col: 0 },
  ":D": { row: 0, col: 1 },
  // ":(": { row: 0, col: 1 },
  // ":D": { row: 0, col: 2 },
  // XD: { row: 0, col: 3 },
  // ":0(": { row: 0, col: 4 },
};

// Function to escape special characters in emoji keys for regex
const escapeRegExp = (string) =>
  string.replace(/[.*+?^=!:${}()|\[\]\/\\]/g, "\\$&");

// Function to extract emojis from text based on emojiMap
export const extractEmojis = (text) => {
  const emojiKeys = Object.keys(emojiMap);

  // Create the regex pattern by joining the keys with `|` (OR operator)
  const emojiPattern = new RegExp(
    `(${emojiKeys.map(escapeRegExp).join("|")})`,
    "g"
  );

  // Split the text by the emoji pattern
  return text.split(emojiPattern);
};

/**
/**
 * Helper function to get the sprite for a specific emoji.
 * @param {string} emoji - The emoji string to look up (e.g., ":)").
 * @returns {Sprite} The corresponding sprite, or null if not found.
 */
export const getEmojiSprite = (emoji, spriteSheet) => {
  const position = emojiMap[emoji];
  if (!position) {
    console.error(`Emoji not found: ${emoji}`);
    return null;
  }

  return spriteSheet.getSprite(position.col, position.row);
};

const spriteSheetURL = "/public/emotes.png"; // Replace with the actual path to your spritesheet
const spriteSize = 24; // Width and height of each emoji in the spritesheet

// Function to replace emoticons in a text with emoji images
export const replaceEmoticonsWithEmoji = (text) => {
  const parts = extractEmojis(text); // Use `extractEmojis` to split the text into segments

  return parts
    .map((part) => {
      const coords = emojiMap[part];
      if (coords) {
        // Return a span with the corresponding emoji if it's an emoticon
        return `<span style="
          display: inline-block;
          width: ${spriteSize}px;
          height: ${spriteSize}px;
          background-image: url('${spriteSheetURL}');
          background-position: -${coords.col * spriteSize}px -${
          coords.row * spriteSize
        }px;
          background-size: auto;
        "></span>`;
      }
      // Return plain text for non-emojis
      return part;
    })
    .join(""); // Combine all parts back into a single string
};
